import React from 'react';
import { makeStyles } from '@material-ui/styles';
import {
  Paper,
  Typography,
  colors,
  Grid,
  Hidden
} from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  title: {
    color: theme.palette.app.primary,
    marginBottom: 10,
  },
  boxBtn: {
    textAlign: 'center',
  },
  buttonsContainer: {
    paddingTop: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  boxContainer: {
    minWidth: 320,
    height: 'auto',
    margin: theme.spacing(4, 8)
  },
  paper: {
    overflow: 'auto',
    backgroundColor: 'unset',
    boxShadow: 'none'
  },
  loginContainer: {
    display: 'flex',
    flex: 1,
    height: '100%',
    flexDirection: 'column'
  },
  errorMessage: {
    color: colors.red[500],
    marginTop: 20,
    textAlign: 'center',
  },
  loginTitle: {
    color: theme.palette.app.primary,
    fontWeight: 'bold',
    textAlign: 'left',
    marginBottom: theme.spacing(2),
  },
  loginDescription: {
    color: '#464F73',
    fontSize: 16,
    textAlign: 'left',
  },
  loginBottom: {
    color: '#464F73',
    fontSize: 14,
    textAlign: 'left',
    marginTop: theme.spacing(3)
  },
  loginNav: {
    color: theme.palette.app.primary,
    textDecoration: 'none',
  },
  loginForm: {

  },
  inputField: {
    backgroundColor: 'white'
  },
  passwordContainer: {
    position: 'relative',
  },
  eyeBtn: {

  },
  button: {
    height: 40,
    cursor: 'pointer',
  },
  forgotPassword: {
    textAlign: 'center',
  },
  forgotPasswordNav: {
    color: theme.palette.app.primary,
    textDecoration: 'none',
    marginTop: theme.spacing(3),
    //fontWeight: 'bold',
    fontSize: 14
  },
  signin: {
    backgroundColor: theme.palette.app.primary,
    borderRadius: 5,
    paddingTop: 14,
    paddingBottom: 14,
    margin: theme.spacing(1, 0)
  },
  signup: {
    backgroundColor: theme.palette.app.lightBlue,
    display: 'block',
    margin: `${theme.spacing(1)}px auto`,
    width: 204,
    borderRadius: 20,
  },
  rightSection: {
    backgroundImage: 'url(/images/login.png)',
    backgroundSize: 'cover',
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0
  },
  logo: {
    height: 48,
    backgroundColor: 'white',
    borderRadius: '0px 0px 30px 30px',
    padding: '10px 18px',
    boxShadow: '0px 8px 35px rgba(6, 56, 63, 0.1)',
    marginBottom: 10
  },
  header: {
    display: 'flex',
    justifyContent: "space-between",
    paddingRight: theme.spacing(4),
    paddingLeft: theme.spacing(8),
    backgroundColor: theme.palette.app.primary,
    minHeight: 62
  },
  signupBtn: {
    textTransform: 'none',
    borderRadius: 8,
    margin: theme.spacing(2, 1),
    border: "1px solid white",
    "&:hover": {
      border: '1px solid transparent'
    }
  },
  disabledBtn: {
    color: `${'white'} !important`,
    border: 'none'
  },
  content: {
    height: 'calc(100vh - 62px)'
  },
  leftSide: {
    display: 'flex',
    alignItems: 'center'
  },
  label: {
    fontWeight: 'bold',
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(0.5)
  },
  divider: {
    display: "flex",
    alignItems: "center",
    margin: theme.spacing(2, 0)
  },
  border: {
    borderBottom: "1px solid #E5E3F2",
    width: "100%"
  },
  dividercontent: {
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
    paddingRight: theme.spacing(2),
    paddingLeft: theme.spacing(2)
  },
  dividerText: {
    textTransform: 'uppercase',
    whiteSpace: 'nowrap',
    color: '#6E7697',
    fontSize: 12
  },
  socialBtn: {
    border: '1.5px solid #E5E3F2',
    borderRadius: 5,
    paddingTop: 12,
    paddingBottom: 12,
    color: '#81879F',
    textTransform: 'none'
  }
}));
const APAVEIMAGE = require('assets/images/apave.png');
const Login = () => {
  const classes = useStyles();
  return (
    <div className={classes.loginContainer}>
      <div className={classes.header}>
        <img src={APAVEIMAGE} alt="apave" className={classes.logo} />
      </div>
      <Grid container className={classes.content}>
        <Grid sm={12} md={5} className={classes.leftSide}>
          <div className={classes.boxContainer}>
            <Paper className={classes.paper} elevation={3} square>
              <form className={classes.loginForm}>
                <Typography className={classes.loginTitle} variant="h4">
                  {"Maintenance en cours, veuillez revenir plus tard."}
                </Typography>

                {/* <div className={classes.buttonsContainer}>
                  <Button
                    variant="contained"
                    color="primary"
                    className={classes.signin}
                    onClick={onSignIn}
                    fullWidth
                  >
                    {t("login.connect")}
                  </Button>

                  <Typography className={classes.loginBottom}>
                    {t("login.terms1")}{' '}
                    <a
                      className={classes.loginNav}
                      href="https://www.apave.com/mentions-legales"
                      target="_blank"
                    >
                      <strong>{t("login.terms2")}</strong>
                    </a>{' '}
                    {t("login.terms3")}{' '}
                    <a
                      className={classes.loginNav}
                      href="https://www.apave.com/politique-de-protection-des-donnees"
                      target="_blank"
                    >
                      <strong>{t("login.terms4")}</strong>
                    </a>{' '}
                    {t("login.terms5")}
                  </Typography>
                </div> */}
              </form>
            </Paper>

          </div>
        </Grid>
        <Hidden smDown>
          <Grid sm={12} md={7} style={{ position: 'relative' }}>
            <div className={classes.rightSection} />
          </Grid>
        </Hidden>
      </Grid>


    </div>
  );
};

export default Login;